export const DEFAULT_LIFETIME_NUMBER_OF_YEARS = 2;
